module.exports = __webpack_public_path__ + "img/859.2abd6c89.gif";